import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class Rows extends PureComponent {
  constructor(props) {
    super(props);

    const { containerClassName } = props;

    this.containerClassName = classnames(
      'brzw-calendar-rows',
      'layout-box l__flexes-to-1 l__scrolls',
      containerClassName,
    );
  }

  render() {
    const { children, containerRef } = this.props;

    return (
      <div className={this.containerClassName} ref={containerRef}>
        {children}
      </div>
    );
  }
}

Rows.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  containerClassName: PropTypes.string,
  containerRef: PropTypes.shape({}),
};

Rows.defaultProps = {
  containerClassName: '',
};

export default Rows;
